// US Production Environment Configuration
// Project: roboflow-platform
// Region: us-central1

module.exports = {
    env: "prod",
    region: "us",
    gcpRegion: "us-central1",
    gcpProjectId: "roboflow-platform",

    // Capability flags — controls which crons/integrations run in this environment
    salesforce: { enabled: true },
    oakExport: { enabled: true },
    depthaiExport: { enabled: true },
    luxonisBlobExport: { enabled: true },

    // Domain configuration
    urlDomain: "roboflow.com",
    cookieDomain: ".roboflow.com",

    // URLs
    urls: {
        app: "https://app.roboflow.com",
        public: "https://public.roboflow.com",
        public2: "https://public2.roboflow.com",
        universe: "https://universe.roboflow.com",
        rapid: "https://rapid.roboflow.com",
        rapidStreamApi: "https://us-central1-roboflow-platform.cloudfunctions.net/rapid-v2-server",
        models: "https://models.roboflow.com",
        api: "https://api.roboflow.com",
        admin: "https://admin.roboflow.com/",
        demo: "https://demo.roboflow.com",
        upload: "upload.roboflow.com",
        serverless: "https://serverless.roboflow.com",
        workflowAssistant:
            "https://us-central1-roboflow-platform.cloudfunctions.net/light-v2-query",
        dedicatedDeployments: "roboflow.cloud"
    },

    // Inference endpoints
    inference: {
        classification: "https://serverless.roboflow.com",
        instanceSegmentation: "https://serverless.roboflow.com",
        semanticSegmentation: "https://segment.roboflow.com",
        objectDetection: "https://serverless.roboflow.com",
        serverless: "https://serverless.roboflow.com",
        sam: "https://smartpoly.svc.roboflow.com/smartpoly/v2/inference",
        ritm: "https://smartpoly.svc.roboflow.com/smartpoly/v1/inference",
        autoLabel: "https://inference-internal.crusoe.roboflow.com",
        owlv2: "https://inference-internal.crusoe.roboflow.com/owlv2/infer",
        gpuWorkflow: "https://serverless.roboflow.com/workflows/run"
    },

    // Redis configuration
    redis: {
        billing: "10.227.65.20:6379",
        cache: "10.244.146.180:6379",
        flush: { host: "10.145.83.100", port: 6379 }
    },

    vpcConnector: "elasticsearch",

    // Spanner configuration
    spanner: { instanceId: "spanner-instance-production" },

    // Firebase configuration
    firebase: {
        projectId: "roboflow-platform",
        projectNumber: "481589474394",
        appId: "1:481589474394:web:1e35528067deb71ccf9463",
        databaseURL: "https://roboflow-platform.firebaseio.com",
        storageBucket: "roboflow-platform-regional-sources",
        locationId: "us-central",
        apiKey: "AIzaSyDsw1Li1kplPtTZ_1mkkzgbGLX55KJcxWo",
        authDomain: "app.roboflow.com",
        messagingSenderId: "481589474394",
        measurementId: "G-3991Z8P4PM",
        consoleUrl:
            "https://console.firebase.google.com/u/0/project/roboflow-platform/firestore/data/",
        appCheckSiteKey: "6Ld3XV0pAAAAAGat8anPuStU8ZWs_zWPmMRiXLoT"
    },

    // CDN configuration
    cdn: {
        source: "source.roboflow.com",
        repo: "repo.roboflow.com",
        coreModelsRepo: "repo.roboflow.com",
        userContent: "https://usercontent.roboflowstatic.com",
        assets: "https://cdnassets.roboflow.com"
    },

    // Third-party services
    pusher: { appId: "ehclfa58" },
    intercom: {
        appId: "ehclfa58",
        sharedSupportAccountId: "7844135",
        teamIds: { growthSales: "7779818", selfServeSupport: "7768952" }
    },
    customerIo: { siteId: "bd767cfa913dbbe0bac4" },
    segment: { frontendWriteKey: "eXtDJCxffULSITBEV2KMzv7MwuBkMvty" },
    posthog: { apiKey: "phc_7vHmsEBQdrH92qV7ePSX6xxaJPEP9GrZMt557NI5ZhV" },
    reddit: { appId: "a2_givxsedjefz9" },
    turnServer: { urls: "turn:turn1.roboflow.com:3478" },

    // BigQuery configuration
    bigQuery: {
        enabled: true,
        dataset: "roboflow_app_server_prod",
        workspace: "roboflow-platform.roboflow_app_server_prod",
        universeDatasetStats:
            "roboflow-platform.product_scheduled_query_results.prod_universe_dataset_stats"
    },

    // Model monitoring
    modelMonitoring: { apiUrl: "https://model-monitoring-apiservice-li37nwjfaq-uc.a.run.app" },

    // Model evaluation
    modelEval: {
        dockerUri: "us-central1-docker.pkg.dev/roboflow-platform/model-eval/model-eval",
        roboflowApiUrl: "https://api.roboflow.com",
        roboflowAppUrl: "https://app.roboflow.com",
        objectDetectionInferenceEndpoint: "https://serverless.roboflow.com",
        asyncInferenceEndpoint: "https://serverless.roboflow.com"
    },

    // Buckets - keys are the aliases used by bucket() function
    buckets: {
        "train": "roboflow-platform-train",
        "cache": "roboflow-platform-cache",
        "sources": "roboflow-platform-regional-sources",
        "exports": "roboflow-platform-regional-exports",
        "transforms": "roboflow-platform-regional-transforms",
        "train-resume": "roboflow-platform-resume-training-files",
        "train-log": "com-roboflow-failed-train-logs-prod",
        "data-sharing": "data-sharing-prod",
        "embeddings": "roboflow-platform-embeddings",
        "weights-upload": "roboflow-platform-weights-upload",
        "videos": "roboflow-platform-videos",
        "core-models-tfjs": "roboflow-platform-core-models-tfjs",
        "usercontent": "roboflow-platform-usercontent",
        "iris-input-data": "roboflow-platform-iris-input-data",
        // Internal buckets (not used via bucket() alias)
        "core-models": "roboflow-platform-core-models",
        "trt-compilation": "roboflow-platform-trt-compilation",
        "autodistill": "com-roboflow-autodistill-prod",
        "fb-export": "roboflow-periodic-backups-prod",
        "data-staging": "roboflow-production-data-staging",
        "batch-processing": "roboflow-production-batch-processing",
        "goat-models-service-recovery": "roboflow-production-model-registry-recovery",
        // upload bucket has a 7 day TTL policy
        "upload": "roboflow-platform-upload"
    },

    // Cloudflare R2
    r2: {
        coreModelsCache: "roboflow-prod-core-models-cache",
        endpoint: "https://core-models.roboflow.com"
    },

    // PubSub topics
    pubsub: {
        batchProcessing:
            "projects/rf-batch-prod/topics/roboflow-production-batch-processing-events",
        dataStaging: "projects/rf-batch-prod/topics/roboflow-production-image-shards-uploaded",
        goatModelsService: "projects/roboflow-platform/topics/goat-models_w_dlq"
    },

    // Device monitoring
    clickhouseDeviceMonitoring: { serviceId: "b83fbb27-f073-43f3-97ee-7fa617932d4e" },

    // Super admins
    superAdmins: [
        "5w20VzQObTXjJhTjq6kad9ubrm33", // Brad Dwyer, CTO
        "Ly2DeBzbwsemGd2ReHk4BFxy8683", // Joseph Nelson, CEO
        "7KZi54uMlMh8cKhNlnczLDf7aqA3", // Sachin Agarwal, Infra Lead
        "ZZYYwu6mWTTX7NY9RRbEkIIKDQs1", // Kate Wagner, Ops Lead
        "dBpG2JyH97Vl1fzfkydRLszHlBg1" // Shawn Adams, IT Specialist
    ],

    // Internal IPs
    internalServiceIPs: [
        // prod us-central1 v3
        "34.173.53.185",
        "34.44.85.169",
        "34.42.204.83",
        "35.238.79.163",
        "104.155.129.44",
        "35.224.68.25",
        "34.68.156.103",
        "35.225.40.58",
        // dedicated us-central1 v1
        "35.223.93.90",
        "34.135.139.5"
    ],

    // Secrets references
    modelsServiceSecretRef: "projects/481589474394/secrets/MODELS_SERVICE_INTERNAL_SECRET",

    // Service accounts
    zipUploadTriggerServiceAccount: "zip-upload-trigger@roboflow-platform.iam.gserviceaccount.com",

    // Bucket mirror / sync config
    bucketMirror: {
        awsAccountId: "507225110954",
        gcpServiceAccount: "bucket-sync@roboflow-platform.iam.gserviceaccount.com",
        audience: "roboflow-platform",
        gcpAccessRoleArn: "arn:aws:iam::507225110954:role/rf-production-bucket-sync-gcp-access",
        adminApiRoleArn: "arn:aws:iam::507225110954:role/rf-production-bucket-sync-gcp-admin-api",
        apiEndpoint: "https://ne0m3n6v72.execute-api.us-east-1.amazonaws.com/production",
        apiVpcEndpoint:
            "https://vpce-00f2f3e68728e7e97-euttixso.execute-api.us-east-1.vpce.amazonaws.com/production",
        s3VpceId: "vpce-0f6ea6d12983fc1f4",
        s3VpceDns:
            "bucket.vpce-0f6ea6d12983fc1f4-cmi83866-us-east-1c.s3.us-east-1.vpce.amazonaws.com"
    },

    // Train clusters
    trainClusters: {
        "goog-us-central1": {
            k8sClusterName: "k8s-prod-v3",
            region: "us-central1",
            projectId: "roboflow-platform",
            hasSpot: true,
            hasOndemand: true,
            timeZone: "America/Chicago",
            location: "US",
            gpuTypes: ["t4"],
            gpuPrefer: { t4: 100 }
        },
        "goog-eu-west4": {
            k8sClusterName: "k8s-prod-eu-v3",
            region: "europe-west4",
            projectId: "roboflow-platform-eu",
            hasSpot: true,
            hasOndemand: true,
            timeZone: "Europe/Amsterdam",
            location: "EU",
            gpuTypes: ["t4"],
            gpuPrefer: { t4: 100 }
        },
        "crusoe-train": {
            k8sClusterName: "crusoe-train",
            region: "us-central1",
            projectId: "roboflow-platform",
            hasSpot: false,
            hasOndemand: true,
            timeZone: "America/Chicago",
            location: "US",
            crusoeRegistry:
                "registry.us-east1-a.ccr.crusoecloudcompute.com/roboflow-gcp-ar-mirror.70f7df3a"
        }
    },

    // Image suggestions dataset
    imageSuggestionsDataset: {
        workspaceId: "8IqlCQUz92pfe9BWFgXB",
        projectId: "rsh8bxDtSqQ2LHdfiGNi"
    },

    // COCO model reference
    cocoModel: "coco/3",

    // YOLO-NAS COCO models
    yolonasCocoModels: {
        url: "coco",
        name: "MS COCO",
        owner: "BTRTpB7nxxjUchrOQ9vT",
        type: "object-detection",
        versions: [
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_s",
                tfjs: false,
                id: "14",
                results: { map: 0.522 }
            },
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_m",
                tfjs: false,
                id: "15",
                results: { map: 0.54 }
            },
            {
                name: "Best",
                annotation: "Common Objects",
                modelType: "yolo_nas_l",
                tfjs: false,
                id: "16",
                results: { map: 0.487 }
            }
        ]
    },

    // Stripe configuration (full config)
    stripe: {
        publishableKey: "pk_live_bkyBGUk4zrQEooH7WnY4a9rv00rPgkXgkJ",
        coupons: { opencv: "LOoC4uzG" },
        products: {
            sourceImage: "price_1GvnZFJRyZoEkwsrtnGJVH6F",
            generatedImage: "price_1GvnVoJRyZoEkwsrxQD8MA88"
        },
        starterPlan: {
            productId: "prod_NbWTXr8J4ozZGr",
            priceId: "price_1MqJQBJRyZoEkwsroBCdiRmG",
            annualPriceId: "price_1MqJbEJRyZoEkwsrDnkbu47n",
            expansionProductId: "prod_NzuY8AA0dikwf0",
            expansionPriceId: "price_1NDujQJRyZoEkwsr9sSsQScJ",
            expansionAnnualPriceId: "price_1NDujQJRyZoEkwsrcDHk7Nwj",
            legacyProductId: "prod_NMwVbgaeXoOVuO",
            customExpansion: {
                images: {
                    productId: "prod_OIGBguUoOK721Z",
                    priceId: "price_1NVffbJRyZoEkwsrBjcFaiOB",
                    upsellPriceId: "price_1NVffbJRyZoEkwsrA2vvGWdY",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 19,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                inferences: {
                    productId: "prod_OIGDKiELQAbrOK",
                    priceId: "price_1NbClQJRyZoEkwsruI3FNXYM",
                    upsellPriceId: "price_1NbCltJRyZoEkwsropp4ltms",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 3,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                adminCollaborators: {
                    productId: "prod_OIGEApGkv0zTu6",
                    priceId: "price_1NVfi5JRyZoEkwsreBCW8FPU",
                    upsellPriceId: "price_1NVfi5JRyZoEkwsr6dMHn6ON",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 99,
                    quantityPerUnit: 1,
                    max: Infinity
                },
                trainCredits: {
                    productId: "prod_OIGGyKjZNePnCd",
                    priceId: "price_1NijYHJRyZoEkwsrUB67yWl7",
                    upsellPriceId: "price_1NijY5JRyZoEkwsruKeO4A1z",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 60,
                    quantityPerUnit: 5,
                    max: Infinity
                },
                rbac: {
                    productId: "prod_OXD3mWPu8d3F8y",
                    priceId: "price_1Nk8dWJRyZoEkwsrkOzuj3C9",
                    upsellPriceId: "price_1NkTICJRyZoEkwsreMoESkFf",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 179,
                    quantityPerUnit: 1,
                    max: 1,
                    labelers: 5,
                    reviewers: 2
                }
            },
            offers: {
                oak: { priceId: "price_1OEjSzJRyZoEkwsrP8xgxgT3", displayName: "OAK-D Lite" },
                outsourcedLabeling: {
                    priceId: "price_1OEjT6JRyZoEkwsrTnwxGmoJ",
                    displayName: "Free Outsourced Labeling"
                },
                trainingCredits: {
                    priceId: "price_1OP92oJRyZoEkwsrc3zCqvog",
                    displayName: "30 Training Credits"
                }
            }
        },
        basicPlan: {
            productId: "prod_RF3qLWCLf2ksyA",
            priceId: "price_1QMZj2JRyZoEkwsrXlaSAV6P",
            annualPriceId: "price_1QMZj2JRyZoEkwsr303949Ie"
        },
        corePlan: {
            productId: "prod_TWeuYOVbht1qyT",
            priceId: "price_1SZbb0JRyZoEkwsrfieBZzNY",
            annualPriceId: "price_1SZbb0JRyZoEkwsrnyghWGIy",
            customExpansion: {
                adminCollaborators: {
                    productId: "prod_TZDEGuJC04LwG5",
                    priceId: "price_1Sc4oFJRyZoEkwsrxdMSF4pg",
                    annualPriceId: "price_1Sc4oFJRyZoEkwsr9vppEkNA",
                    upsellDiscountPercent: 0,
                    pricePerUnit: 29,
                    quantityPerUnit: 1,
                    max: 7
                }
            }
        },
        growthPlan: {
            productId: "prod_RF3pzEPmLtxyei",
            priceId: "price_1QMZi7JRyZoEkwsrU4lXzDGx",
            annualPriceId: "price_1QMZi7JRyZoEkwsrQH3JtQZ5"
        },
        autoLabel: {
            productId: "prod_PmSHPamzyKPXfB",
            default: [
                { priceId: "price_1OzNERJRyZoEkwsropzg9WCO", price: 15, credits: 500 },
                { priceId: "price_1OwtMnJRyZoEkwsrGItRz309", price: 29, credits: 1000 },
                { priceId: "price_1OwtMnJRyZoEkwsrJP1jPdkY", price: 129, credits: 5000 },
                { priceId: "price_1OwtMnJRyZoEkwsrHVqy425m", price: 249, credits: 10000 }
            ],
            starter: [
                { priceId: "price_1OwtMnJRyZoEkwsr1mNFM06T", price: 49, credits: 2500 },
                { priceId: "price_1OwtMnJRyZoEkwsreJdT8aCn", price: 179, credits: 10000 },
                { priceId: "price_1OwtMnJRyZoEkwsr7ZbIRfAu", price: 349, credits: 25000 },
                { priceId: "price_1OwtMnJRyZoEkwsrngEBtePJ", price: 599, credits: 50000 },
                { priceId: "price_1OwtMnJRyZoEkwsrxaL62Kei", price: 999, credits: 100000 }
            ]
        },
        flexUsage: {
            hostedInferencesProductId: "prod_R0XXQQg3v3s0Hv",
            hostedInferencesPriceId: "price_1Q8WSRJRyZoEkwsr9ejM1h3k",
            roboflowCreditsProductId: "prod_REg4TqxQk90Mi6",
            roboflowCreditsMeterId: "mtr_61RVafJinVykqTl7T41JRyZoEkwsrTYu",
            roboflowPrepaidCreditsProductId: "prod_RbDh2bGTqYEiiU"
        }
    },

    // Docs workspace
    docsWorkspaceId: "JiQGYrduYqL8c9jTMgoQ",

    // Sample dataset and large workspaces
    sampleDataset: "OXcbAdpFrioGUqaxPaZo",
    largeWorkspaces: ["WStLbW6Owiz8aE9Z5N23"],

    // SFDC SAML SSO config
    sfdcSamlSso: {
        acsUrl: "https://support.roboflow.com/vforcesite/login",
        spEntityId: "https://support.roboflow.com",
        idpEntityId: "https://app.roboflow.com/query/sfdc-saml"
    },

    // Support config
    supportTeam: { id: "d83QKocE3qOxGTdMw3el" },
    supportUser: { id: "9ktbryvmx3bot1H2TsLNLotPR2C3", email: "help@roboflow.com" }
};
